import { render, staticRenderFns } from "./HoneyComb.vue?vue&type=template&id=02f8fbed"
import script from "./HoneyComb.vue?vue&type=script&lang=js"
export * from "./HoneyComb.vue?vue&type=script&lang=js"
import style0 from "./HoneyComb.vue?vue&type=style&index=0&id=02f8fbed&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports